import React from "react";
import { DoctorStamp } from "@/components/prescriptions/QrOverlay.jsx"; // or wherever you export it from
import { useTheme } from "@/contexts/ThemeContext.jsx";

export default function SignatureStampLine({
  sigSrc,
  sigAlt = "Doctor signature",
  sigClassName = "h-[68px] w-[120px]",
  stampBaseSrc,
  doctorName,
  regNo,
  stampIsDark,
  stampSizePx = 96,
  // tiny per-asset nudges (stable, not “magic per screen”)
  sigNudgeY = 2,     // +down, -up
  stampNudgeY = 2,   // +down, -up
  lineClassName,
}) {
  const { isDark } = useTheme();
  const resolvedLineClassName =
    lineClassName ||
    (isDark
      ? "border-[rgba(var(--clr-outline-variant),0.55)]"
      : "border-[rgba(2,6,23,0.18)]");

  return (
    <div className="relative mt-3">
      {/* Row */}
      <div className="flex items-end justify-between gap-4">
        <img
          src={sigSrc}
          alt={sigAlt}
          className={`${sigClassName} object-contain`}
          draggable="false"
          style={{ transform: `translateY(${sigNudgeY}px)` }}
        />

        {stampBaseSrc ? (
          <div style={{ transform: `translateY(${stampNudgeY}px)` }}>
            <DoctorStamp
              baseSrc={stampBaseSrc}
              doctorName={doctorName}
              regNo={regNo}
              isDark={stampIsDark ?? isDark}
              sizePx={stampSizePx}
            />
          </div>
        ) : null}
      </div>

      {/* Dotted line anchored under the row */}
      <div className={`mt-1 border-b border-dashed ${resolvedLineClassName}`} />
    </div>
  );
}
